module.exports = __webpack_public_path__ + "static/media/HeroSection.232a6a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/HeroSection.png
// module id = 1872
// module chunks = 0